import { Table2 } from 'lucide-react';

interface TableEmptyProps {
  title?: string;
  description?: string;
}

const TableEmpty = ({
  title = 'No hay mesas para mostrar',
  description = 'Cree la primera mesa o cambie los filtros aplicados.',
}: TableEmptyProps) => {
  return (
    <div className="flex min-h-[320px] flex-col items-center justify-center px-6 text-center">
      <div className="mb-5 flex h-20 w-20 items-center justify-center rounded-2xl border-2 border-primary/20 bg-primary/10 text-primary">
        <Table2 className="h-10 w-10" />
      </div>

      <h3 className="text-lg font-semibold text-black dark:text-white">
        {title}
      </h3>

      <p className="mt-2 max-w-md text-sm leading-relaxed text-bodydark2">
        {description}
      </p>
    </div>
  );
};

export default TableEmpty;